import React, { Component } from "react";
import { Collapse } from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import classname from "classnames";

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    var matchingMenuItem = null;
    var ul = document.getElementById("navigation");
    var items = ul.getElementsByTagName("a");
    for (var i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  activateParentDropdown = (item) => {
    item.classList.add("active");
    const parent = item.parentElement;

    if (parent) {
      parent.classList.add("active"); // li
      const parent2 = parent.parentElement;
      parent2.classList.add("active"); // li
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add("active"); // li
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add("active"); // li
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add("active"); // li
          }
        }
      }
    }
    return false;
  };
  render() {
    return (
      <React.Fragment>
        <div className="topnav">
          <div className="container-fluid">
            <nav className="navbar navbar-light navbar-expand-lg topnav-menu">
              <Collapse
                isOpen={this.props.menuOpen}
                className="navbar-collapse"
              >
                <div id="navigation">
                  <ul className="navbar-nav">
                    <li className="nav-item">
                      <Link className="nav-link" to="/home">
                        <i className="ti-home mr-2 ml-2"></i>
                        <span>Home</span>
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link className="nav-link" to="/users">
                        <i className="ion ion-ios-person mr-2 ml-2"></i>
                        <span>Users</span>
                      </Link>
                    </li>

                    <li className="nav-item dropdown mega-dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to="/logs"
                        // onClick={(e) => {
                        //   e.preventDefault();
                        //   this.setState({
                        //     AuthState: !this.state.AuthState,
                        //   });
                        // }}
                      >
                        <i className="ion ion-ios-time mr-2 ml-2"></i>
                        <span>Logs</span>
                      </Link>

                      <div
                        className={classname("dropdown-menu", {
                          show: this.state.AuthState,
                        })}
                      >
                        <div className="row">
                          <div className="col-lg-6">
                            <div>
                              <Link
                                to="/site_access_logs"
                                className="dropdown-item"
                              >
                                Site Access
                              </Link>
                              <Link
                                to="/user_management_logs"
                                className="dropdown-item"
                              >
                                User Management
                              </Link>
                              <Link
                                to="/export_import_logs"
                                className="dropdown-item"
                              >
                                Export
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li className="nav-item dropdown mega-dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to="/auto_diagnosis"
                        // onClick={(e) => {
                        //   e.preventDefault();
                        //   this.setState({
                        //     AuthState: !this.state.AuthState,
                        //   });
                        // }}
                      >
                        <i className="ion ion-ios-medkit mr-2 ml-2"></i>
                        <span>Auto Diagnosis Menu</span>
                      </Link>

                      <div
                        className={classname("dropdown-menu", {
                          show: this.state.AuthState,
                        })}
                      >
                        <div className="row">
                          <div className="col-lg-6">
                            <div>
                              <Link to="/dashboard" className="dropdown-item">
                                Dashboard
                              </Link>
                              <Link
                                to="/diagnosis_list"
                                className="dropdown-item"
                              >
                                Diagnosis
                              </Link>
                              <Link
                                to="/versions_list"
                                className="dropdown-item"
                              >
                                Versions
                              </Link>
                              <Link
                                to="/tickets_list"
                                className="dropdown-item"
                              >
                                Reports From Fields
                              </Link>
                              <Link to="/parametri" className="dropdown-item">
                                Parametri
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li className="nav-item dropdown mega-dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to="/ac_diagnosis"
                        // onClick={(e) => {
                        //   e.preventDefault();
                        //   this.setState({
                        //     AuthState: !this.state.AuthState,
                        //   });
                        // }}
                      >
                        <i className="mdi mdi-air-conditioner mr-2 ml-2"></i>
                        <span>AC MENU</span>
                      </Link>

                      <div
                        className={classname("dropdown-menu", {
                          show: this.state.AuthState,
                        })}
                      >
                        <div className="row">
                          <div className="col-lg-6">
                            <div>
                              <Link
                                to="/ac_dashboard"
                                className="dropdown-item"
                              >
                                AC Dashboard
                              </Link>
                              <Link
                                to="/ac_machine_operations"
                                className="dropdown-item"
                              >
                                AC Machine Operations
                              </Link>
                              <Link to="/ac_versions" className="dropdown-item">
                                AC Version
                              </Link>
                              <Link
                                to="/ac_operations"
                                className="dropdown-item"
                              >
                                AC Auto Operations
                              </Link>
                              <Link
                                to="/ac_man_operations"
                                className="dropdown-item"
                              >
                                AC Manual Operations
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </Collapse>
            </nav>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(Navbar);
